import { z } from 'zod';
import { baseDocSchema, localeSchema, objectIdSchema } from './common.js';
import { countryCodeSchema } from './organization.js';

export const orgRoleSchema = z.enum(['owner', 'admin', 'seller', 'scanner']);
export type OrgRole = z.infer<typeof orgRoleSchema>;

export const userMembershipSchema = z.object({
  orgId: objectIdSchema,
  role: orgRoleSchema,
  joinedAt: z.coerce.date(),
});
export type UserMembership = z.infer<typeof userMembershipSchema>;

export const userSchema = baseDocSchema.extend({
  email: z.string().email().toLowerCase(),
  name: z.string().min(1).max(120).default(''),
  locale: localeSchema.default('es'),
  emailVerifiedAt: z.coerce.date().nullable().default(null),
  memberships: z.array(userMembershipSchema).default([]),
  /**
   * ISO-3166 alpha-2 of the user, auto-detected from their IP on signup
   * (Cloudflare CF-IPCountry header). Optional because we have no way of
   * filling it for pre-existing accounts and the geo header is not 100%
   * reliable. Used to pre-fill the Stripe Connect onboarding country.
   */
  country: countryCodeSchema.optional(),
  /** Platform-wide admin flag. Distinct from per-org membership roles. */
  isAdmin: z.boolean().default(false),
});
export type User = z.infer<typeof userSchema>;

export const requestMagicLinkInputSchema = z.object({
  email: z.string().trim().toLowerCase().email(),
  redirectTo: z.string().url().optional(),
  /** Cloudflare Turnstile token. Requerido solo si el server tiene captcha activo. */
  captchaToken: z.string().optional(),
});
export type RequestMagicLinkInput = z.infer<typeof requestMagicLinkInputSchema>;
